import VueQueryBuilder from './VueQueryBuilder.vue'
export default VueQueryBuilder;
